import React from "react";
import { useNavigate } from "react-router-dom";

const ProductBannerCard = ({
  image,
  name,
  descr,
  link,
  backgroudColor,
  isDark = false,
}) => {
  const navigate = useNavigate();
  return (
    <div
      className="p-8 flex flex-col items-center relative "
      style={{ backgroundColor: backgroudColor }}
    >
      <img
        src={image}
        alt={name}
        className="h-60 w-60 object-cover rounded-md mb-4"
      />
      <div className="items-center text-center lg:text-left lg:items-left flex flex-col gap-2">
        <p
          className={`text-3xl font-thin text-gray-800 truncate-2-lines ${
            isDark && "text-white"
          }`}
        >
          {name}
        </p>
        <p className="font-base text-[#909090] truncate-3-lines">{descr}</p>
        <button
          onClick={() => navigate(link || `/products`)}
          className={`mt-6 px-6 py-3 border rounded-md transition w-40 ${
            isDark
              ? "border-white text-white hover:bg-white hover:text-black"
              : "border-black text-black hover:bg-black hover:text-white"
          }`}
        >
          Mua ngay
        </button>
      </div>
    </div>
  );
};

export default ProductBannerCard;
